import React from "react";

import { Card } from "react-bootstrap";

function FounderPrayer({ prayer }) {
  return (
    <div>
      <Card className="border-0">
        <Card.Body>
          <Card.Text>{prayer}</Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
}

export default FounderPrayer;
